import {dehydrate, QueryClient} from '@tanstack/react-query';
import React from 'react';

import {GwgAccelerator, getAllGwgAccelerators} from '@udemy/career-academies';
import {disallowSlug, RENDER_MODES} from '@udemy/nextjs-core';

import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';
import {fetcher} from 'src/lib/gql-fetcher';
import {AppContextData} from 'src/types/page-props';

import {PlanComparisonFeature, PlanComparisonFeatureProps} from '../../features/plan-comparison';
import {getStaticAppContext} from '../api/context.api';

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

export const getStaticProps = disallowSlug(async ({locale}) => {
    locale = locale as string;
    const translations = await getCompactTranslations(locale as string);
    const client = new QueryClient();

    const gwgAcceleratorsData = (
        getAllGwgAccelerators as (
            locale: string,
            options?: {customGqlFetcher?: typeof fetcher},
        ) => ReturnType<typeof getAllGwgAccelerators>
    )(locale, {customGqlFetcher: fetcher}).catch(() => [] as GwgAccelerator[]);
    // Resolve appContext
    const [staticData, allGwgAccelerators] = await Promise.all([
        getStaticAppContext({locale}),
        gwgAcceleratorsData,
    ]);
    const appContext: AppContextData = {
        ...staticData,
        // application specific context can go here
    };

    return {
        props: {
            appContext,
            allGwgAccelerators,
            dehydratedState: dehydrate(client),
            locale,
            pageKey: 'consumersubscription_plans_and_pricing',
            translations,
            renderMode: RENDER_MODES.ISR as keyof typeof RENDER_MODES,
        },
        revalidate: FOUR_HOURS,
    };
});

export default function PlanComparisonPage(props: PlanComparisonFeatureProps) {
    return <PlanComparisonFeature allGwgAccelerators={props.allGwgAccelerators} />;
}

PlanComparisonPage.getLayout = PlanComparisonFeature.getLayout;
